import { useTenantData } from '../context/TenantDataContext';

// What the open tenant's licence allows. The answer comes from the backend (`tenant.license`); when it
// is missing (still loading, or an older response) the page is left open rather than locked, since the
// backend is the real gate and refuses the data either way.
const OPEN = { tier: 'premium', expired: false, daysLeft: null, trialEndsAt: null, features: { documentation: true, autoReports: true, dataExport: true, reportWatermark: false } };

export function useLicense() {
  const { tenant } = useTenantData();
  return tenant?.license || OPEN;
}
